// extracted by css-extract-rspack-plugin
export default {"siteExceptionsContent":"site-exceptions-content--pmV5YviJbpc0mLZW"};